import React, { ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from '@material-ui/core';
import get from 'lodash/get';

type TextInputPropsType = {
  name: ComponentProps<typeof Controller>['name'];
  rules?: ComponentProps<typeof Controller>['rules'];
  defaultValue?: ComponentProps<typeof Controller>['defaultValue'];
  rowsMin?: number;
  disabled?: boolean;
} & Partial<TextFieldProps>;

export default function TextInput({
  name,
  defaultValue,
  rules,
  required,
  disabled,
  ...props
}: TextInputPropsType) {
  const { control, errors } = useFormContext();
  const error = get(errors, name);

  return (
    <Controller
      render={({ value, onBlur, onChange, ref }) => (
        <TextField
          value={value ?? ''}
          name={name}
          id={name}
          onBlur={onBlur}
          onChange={onChange}
          inputRef={ref}
          error={Boolean(error)}
          helperText={error?.message}
          required={required}
          disabled={disabled}
          {...props}
        />
      )}
      name={name}
      control={control}
      rules={{ required, ...rules }}
      defaultValue={defaultValue ?? ''}
    />
  );
}
